import { render, staticRenderFns } from "./PaymentNeedsValidation.vue?vue&type=template&id=3bf57840&scoped=true"
import script from "./PaymentNeedsValidation.vue?vue&type=script&lang=js"
export * from "./PaymentNeedsValidation.vue?vue&type=script&lang=js"
import style0 from "./PaymentNeedsValidation.vue?vue&type=style&index=0&id=3bf57840&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf57840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf57840')) {
      api.createRecord('3bf57840', component.options)
    } else {
      api.reload('3bf57840', component.options)
    }
    module.hot.accept("./PaymentNeedsValidation.vue?vue&type=template&id=3bf57840&scoped=true", function () {
      api.rerender('3bf57840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/components/tabs/PaymentNeedsValidation.vue"
export default component.exports